import { render } from "./BaseTemplate.vue?vue&type=template&id=5ad28878&scoped=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&lang=js"

import "./BaseTemplate.vue?vue&type=style&index=0&id=5ad28878&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad28878"]])

export default __exports__